/* eslint-disable @typescript-eslint/no-unused-vars */
import type {
  ArchiveUnarchiveOrganizationTrainerById,
  FetchOrganizationTrainersArgs,
  InviteOrganizationTrainerArgs,
  FetchOrganizationTrainerById,
  EditOrganizationTrainerById,
  DeleteTrainerByIdArgs,
  UiTrainer,
} from './types/trainers.types';
import type {
  BaseApiPaginatedResponse,
  BaseApiResponse,
} from './types/api.types';
import type { ApiTrainer } from '../schemas/trainers.schema';

import { mapTrainerFromApi } from './mappers/trainers.mappers';
import { destroy, post, get, put } from './axios';

export async function deleteOrganizationById({ id }: DeleteTrainerByIdArgs) {
  await destroy(`/v2/trainers/${id}`);
  return true;
}

export async function fetchOrganizationTrainerById({
  id,
  organizationId,
}: FetchOrganizationTrainerById) {
  const response = await get<BaseApiResponse<ApiTrainer>>(
    `/v2/organizations/${organizationId}/trainers/${id}`,
  );
  return mapTrainerFromApi(response?.data);
}

export async function archiveUnarchiveOrganizationTrainerById({
  id,
  organizationId,
  type,
}: ArchiveUnarchiveOrganizationTrainerById) {
  await put(`/v2/organizations/${organizationId}/trainers/${type}/${id}`);
  return true;
}

export async function disconnectOrganizationTrainerById({
  id,
  organizationId,
}: EditOrganizationTrainerById) {
  await put(`/v2/organizations/${organizationId}/trainers/disconnect/${id}`);
  return true;
}

export async function fetchOrganizationTrainers({
  filters,
  organizationId,
}: FetchOrganizationTrainersArgs) {
  const response = await get<BaseApiPaginatedResponse<ApiTrainer[]>>(
    `/v2/organizations/${organizationId}/trainers`,
    {
      query: filters,
    },
  );

  const result = {
    data: response?.data?.flatMap((d) => mapTrainerFromApi(d)) as UiTrainer[],
    message: response?.message || '',
    status: response?.status || 200,
    total: response?.total || 0,
  };

  return result;
}

export async function inviteOrganizationTrainer({
  email,
  organizationId,
  roleIds,
  type,
}: InviteOrganizationTrainerArgs) {
  await post(`/v2/organizations/${organizationId}/trainers/invite-trainer`, {
    email,
    roleIds: roleIds.map((role) => role.value),
    type,
  });
}

export async function assignTrainerToClient({
  clientId,
  organizationId,
  trainerId,
}: {
  organizationId: string;
  trainerId: string;
  clientId: string;
}) {
  await post(
    `/v2/organizations/${organizationId}/trainers/${trainerId}/clients`,
    { clientId },
  );
}

export async function removeTrainerFromClient({
  clientId,
  organizationId,
  trainerId,
}: {
  organizationId: string;
  trainerId: string;
  clientId: string;
}) {
  await destroy(
    `/v2/organizations/${organizationId}/trainers/${trainerId}/clients/${clientId}`,
  );
}
